const filteredProducts: readonly string[] = [
  'Set Bottoms',
  'Intimates Set Bottoms',
  'Intimates Set Skirt',
  'Swim Set Bottoms',
  'Apparel Set Bottoms',
]

export const algoliaGlobalFilter = `(${filteredProducts
  .map((productType) => `NOT product_type:"${productType}"`)
  .join(' AND ')}) AND inventory_available:true`
